import Vue from "vue";
import Vuetify from "vuetify/lib";
import "@mdi/font/css/materialdesignicons.css";
import { $t } from "@/lib/helpers/i18nHelper";

Vue.use(Vuetify);
export default new Vuetify({
  icons: {
    iconfont: "mdi",
  },
  theme: {
    themes: {
      light: {
        primary: "#1976D2",
        secondary: "#424242",
        accent: "#1976D2",
        error: "#FF5252",
        info: "#2196F3",
        success: "#4CAF50",
        warning: "#FB8C00",
      },
    },
    options: {
      customProperties: true,
    },
  },
  lang: {
    t: (key: string, ...params: Array<number | string>) => $t(key, params),
  },
});
